"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-angelo-d-alife": {
    "7e70f363": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f18737bc": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "grotte": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05de69cb": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "melopiano": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cee6bec0": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "rondo": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bfae60f2": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "san-nicola": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bfe1c391": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "selvapiana": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e18058ec": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "taverna-starza": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee9001cf": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "skipSearch": false
    }],
    "vignole": [{
      "hkey": "88e991c6",
      "slug": "sant-angelo-d-alife",
      "name": "Sant'Angelo d'Alife",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;